import React from "react";

import { ReactComponent as CorrectRed } from "../../../images/v2/responseList/assessment/correct_answer_red.svg";
import { ReactComponent as CorrectGreen } from "../../../images/v2/responseList/assessment/correct_answer_green.svg";
import { ReactComponent as CorrectGray } from "../../../images/v2/responseList/assessment/correct_answer_gray.svg";

import { ReactComponent as GuardrailsRed } from "../../../images/v2/responseList/assessment/guardrails_red.svg";
import { ReactComponent as GuardrailsGreen } from "../../../images/v2/responseList/assessment/guardrails_green.svg";
import { ReactComponent as GuardrailsGray } from "../../../images/v2/responseList/assessment/guardrails_gray.svg";

import { ReactComponent as ConflictingKnowledgeRed } from "../../../images/v2/responseList/assessment/c_knowledge_red.svg";
import { ReactComponent as ConflictingKnowledgeGreen } from "../../../images/v2/responseList/assessment/c_knowledge_green.svg";
import { ReactComponent as ConflictingKnowledgeGray } from "../../../images/v2/responseList/assessment/c_knowledge_gray.svg";

import { ReactComponent as KnowledgeGapRed } from "../../../images/v2/responseList/assessment/knowledge_gap_red.svg";
import { ReactComponent as KnowledgeGapGreen } from "../../../images/v2/responseList/assessment/knowledge_gap_green.svg";
import { ReactComponent as KnowledgeGapGray } from "../../../images/v2/responseList/assessment/knowledge_gap_gray.svg";

import { ReactComponent as BadLinksRed } from "../../../images/v2/responseList/assessment/bad_link_red.svg";
import { ReactComponent as BadLinksGreen } from "../../../images/v2/responseList/assessment/bad_link_green.svg";
import { ReactComponent as BadLinksGray } from "../../../images/v2/responseList/assessment/bad_link_gray.svg";

import { ReactComponent as HallucinationRed } from "../../../images/v2/responseList/assessment/hallucination_red.svg";
import { ReactComponent as HallucinationGreen } from "../../../images/v2/responseList/assessment/hallucination_green.svg";
import { ReactComponent as HallucinationGray } from "../../../images/v2/responseList/assessment/hallucination_gray.svg";

import "./css/Assesment.css";

// Function to determine the icon based on ID and evaluation status
const switchIcon = (id, evaluation) => {
    // Normalize evaluation values
    const status = evaluation === true ? "good" : evaluation === false ? "bad" : null;

    switch (id) {
        case "answer_correct":
            return status === "good" ? <CorrectGreen /> :
                   status === "bad" ? <CorrectRed /> :
                   <CorrectGray />;
        case "guardrails":
            return status === "good" ? <GuardrailsGreen /> :
                   status === "bad" ? <GuardrailsRed /> :
                   <GuardrailsGray />;
        case "conflicting_knowledge":
            return status === "good" ? <ConflictingKnowledgeGreen /> :
                   status === "bad" ? <ConflictingKnowledgeRed /> :
                   <ConflictingKnowledgeGray />;
        case "knowledge_gap":
            return status === "good" ? <KnowledgeGapGreen /> :
                   status === "bad" ? <KnowledgeGapRed /> :
                   <KnowledgeGapGray />;
        case "bad_links": // Handles 'bad_links' instead of 'broken_links'
        case "broken_links": // If dataset contains 'broken_links'
            return status === "good" ? <BadLinksGreen /> :
                   status === "bad" ? <BadLinksRed /> :
                   <BadLinksGray />;
        case "hallucination":
            return status === "good" ? <HallucinationGreen /> :
                   status === "bad" ? <HallucinationRed /> :
                   <HallucinationGray />;
        default:
            return null;
    }
};

// Function to return the title based on ID
const switchTitle = (id) => {
    switch (id) {
        case "answer_correct":
            return "Correct Answer";
        case "guardrails":
            return "Guardrails";
        case "conflicting_knowledge":
            return "Conflicting Knowledge";
        case "knowledge_gap":
            return "Knowledge Gap";
        case "bad_links": // Handles 'bad_links'
        case "broken_links": // If dataset contains 'broken_links'
            return "Bad Links";
        case "hallucination":
            return "Hallucination";
        default:
            return "Unknown";
    }
};

const Assesment = ({ assessment, is_first_three }) => {
    // Ensure assessment is an array (parse JSON if needed)
    if(assessment === ""){
        return null;
    }
    let parsedAssessment = [];
    try {
        parsedAssessment = typeof assessment === "string" ? JSON.parse(assessment) : assessment;
    } catch (error) {
        console.error("Error parsing assessment data:", error);
    }

    

    return (
        <div className="assessment-container">
            {parsedAssessment?.map((item, index) => (
                <div key={index} className={`assessment-item ${is_first_three ? "first-three" : ""}`}>
                    <div className="assessment-item-icon">
                        {switchIcon(item.id, item.evaluation)}
                    </div>
                    <div className="assessment-item-description">
                        <h3>{switchTitle(item.id)}</h3>
                        <p>{item.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Assesment;
